export default "__VITE_ASSET__CNuvYYHV__"